import {
  ActionOneParam,
  TResource,
  TServerDeTectFaceData,
  TSign,
  TTemplate,
} from "@/types";
import { getExtension } from "./index";
import { faceDetect, getSignUrl, putFileTo } from "@/api";
import { APICode } from "@/constants";

export const submitFile = (
  file: File,
  url: string,
  onProgress?: ActionOneParam<number>
) => {
  return new Promise<void>((resolve, reject) => {
    putFileTo(file, url, onProgress)
      .then(() => {
        resolve();
      })
      .catch(reject);
  });
};

export const fetchSign = (extension: string) => {
  return new Promise<TSign>((resolve, reject) => {
    getSignUrl(extension)
      .then((res) => {
        const { code, data, msg } = res;
        if (code === APICode.Success) {
          resolve(data);
        } else {
          reject(new Error(msg));
        }
      })
      .catch(reject);
  });
};

export const signTemp = (value: TTemplate) => {
  if (value.resource.url) {
    // 上传过
    return Promise.resolve(value);
  } else {
    return new Promise<TTemplate>((resolve, reject) => {
      fetchSign(getExtension(value.resource.file!))
        .then((sign) =>
          resolve({
            ...value,
            resource: {
              ...value.resource,
              sign: sign as TSign,
            },
          })
        )
        .catch(reject);
    });
  }
};

export const uploadTemp = (value: TTemplate) => {
  if (value.resource.url) {
    return Promise.resolve(value);
  } else {
    return new Promise<TTemplate>((resolve, reject) => {
      submitFile(value.resource.file!, value.resource.sign?.uploadUrl!)
        .then(() =>
          resolve({
            ...value,
            resource: {
              ...value.resource,
              url: value.resource.sign?.downloadUrl,
            },
          })
        )
        .catch(reject);
    });
  }
};
export const checkTempFace = (value: TTemplate) => {
  return new Promise<TServerDeTectFaceData[]>((resolve, reject) => {
    if (value.resource.url) {
      faceDetect(value.resource.url).then((res) => {
        const { faces } = res;
        if (faces.length > 0) {
          resolve(faces as TServerDeTectFaceData[]);
        } else {
          reject(new Error("face not found"));
        }
      });
    }
  });
};

export const signResource = (value: TResource) => {
  if (value.url) {
    // 上传过
    return Promise.resolve(value);
  } else {
    return new Promise<TResource>((resolve, reject) => {
      fetchSign(getExtension(value.file!))
        .then((sign) =>
          resolve({
            ...value,
            sign: sign as TSign,
          })
        )
        .catch(reject);
    });
  }
};
export const uploadResource = (
  value: TResource,
  onProgress?: ActionOneParam<number>
) => {
  if (value.url) {
    return Promise.resolve(value);
  } else {
    return new Promise<TResource>((resolve, reject) => {
      submitFile(value.file!, value.sign?.uploadUrl!, onProgress)
        .then(() =>
          resolve({
            ...value,
            url: value.sign?.key,
          })
        )
        .catch(reject);
    });
  }
};


export const checkResourceFace = (value: TResource) => {
  return new Promise<TServerDeTectFaceData[]>((resolve, reject) => {
    if (value.url) {
      faceDetect(value.url).then((res) => {
        const { faces } = res;
        resolve(faces as TServerDeTectFaceData[]);
      });
    }
  });
}